export const removeTrailingSlash = ( url ) => {

  // skip single slash (it's the homepage)
  if ( url === '/' ) {
    return url
  }

  // trim white space
  url = url.replace(/^\s+|\s+$/g,'')

  // remove trailing slash
  if ( url.substr( url.length -1 ) === '/' ) {
    if (typeof window === 'undefined') { // only log during build
      console.log( 'Removed trailing slash from: ', url )
    }
    return url.replace(/\/+$/, '')
  }

  return url
}

export const forceTrailingSlash = ( url ) => {

    // if it's empty return /
    if( !url ) {
      return '/'
    }

    // if there is an anchor or query param in the url don't add a trailing slash
    if( url.match( /#|\?/i ) ) {
      return url
    }
    // add trailing slash if it's missing
    if( url.substr( url.length -1 ) !== '/' ) {
      url += '/'
    }
    return url
}

// returns a relative url that can be used with gatsby link if it is an internal url
// otherwise it returns false or the original url
// Should be interpreted as external URLs
// lapointcamps.freshdesk.com/support/tickets/new
// www.booking.lapoint.no/mine-bestillinger
// booking.lapoint.no/mine-bestillinger

// Should be interpreted as internal URLs
// www.lapointcamps.com/blogg/informasjon-om-covid-19
// lapoint.no/surfcamp/portugal/portugal-ericeira/work-and-surf/
// /surfcamp/portugal/portugal-ericeira/work-and-surf/

// TODO: think about this 
// https://lapointcamps.com/blog/entry turns into a relative link i.e /blog/entry
// while
// //lapointcamps.com/blog/entry turns into an external link i.e https://lapointcamps.com/blog/entry
export const convertToInternalUrl = ( url, returnOriginalIfExternal=false ) => {

/* REMOVE THIS COMMENT 
  //let match = url.match(/^(?:.*(lapoint)(?:camps)?\.(?:com|ch|de|dk|no|se))(.*)/i)

  //let match = url.match(/^(?:http[s]?:\/\/)?(.*)(lapoint)(?:camps)?\.(?:com|ch|de|dk|no|se|at|fr)(.*)/i)
  // (?:http[s]?:\/\/)? = optional non capturing group looking to match http:// or https://
  // (.*) = capture group 1 captures anything that comes before lapoint or lapointcamps if this is anything except www. the link is to a subdomain e.g booking.lapoint.se
  // (lapoint)(?:camps)?\.(?:com|ch|de|dk|no|se) = capture group 2 captures lapoint in group 2 and this tells us it is an internal link
  // (.*) = capture group 3 captures the path that should be used as the relative link if it is an internal link

  // the regex will match if lapoint.xx or lapointcamps.com is in the url with or without protocol
  // https://www.lapoint.se/surfcamp, https://lapoint.se/surfcamp, //lapoint.se/surfcamp, lapoint.se/surfcamp
      
  // if the regex doesn't match then the url is either relative i.e without the domian eg: /blog/path-to-post, /surfcamp/portugal/ericeira
  // or an external url. external urls must start with a protocol. also check for tel: and mailto: as they should not be converted
*/

  // if there is no protocol we interpret it as an internal url
  if( ! url.match( /^(http[s]?:\/\/)|(tel:)|(mailto:)/i ) ) {
    
    // remove  www.lapoint.. or lapoint... from the url
    let match = url.match( /^(?:www.)?(lapointcamps\.com|lapoint\.(?:at|ch|de|dk|fr|no|se))/i )
    if( match ) {
      url = url.replace( match[0], '' )
    }
    return forceTrailingSlash( url )
  }

  // parse the url
  const parsedURL = new URL( url )

  // if the protocol is tel: or mailto: we return
  if( parsedURL.protocol === "tel:" | "mailto:" ) {
    return false
  }

  // For an internal URL the host should lapointcamps.com or lapoint.se|at|ch|de|dk|fr|no
  // i.e no subdomains
  // we use a regex to find out
  if( ! parsedURL.host.match( /^(?:www.)?(lapointcamps\.com|lapoint\.(?:at|ch|de|dk|fr|no|se))/i ) ) {
    return returnOriginalIfExternal ? url : false 
  }

  // we got this far

  // if the pathname is /sitemap.xml we should not treat it as an internal URL
  // there is a special case for this in Link.js
  if( parsedURL.pathname === "/sitemap.xml" ) {
    return false
  }

  // return pathname which is the relative part of the URL and the hash if there is one
  return forceTrailingSlash( parsedURL.pathname ) + parsedURL.hash 
  
}